import { Injectable } from '@angular/core';
import { IConfigSettingService } from './iconfig-setting.service';
import { ApiService, ApiCacheOptions } from '../../../shared/index';
import { ConfigSetting } from '../config-setting.model';
import { MembershipDropActionsDto } from 'src/app/admin/member-drop-actions/membership-drop-actions.dto';
import { BatchDropSettingsDto } from 'src/app/admin/batch-drop-settings/batch-drop-settings.dto';
import { ProfileSelectorSettingsDto } from 'src/app/admin/profile-selector-settings/profile-selector-settings.dto';

@Injectable()
export class ConfigSettingService implements IConfigSettingService {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  // gets a config setting by batch, group and name. settingBatch is optional.
  public getConfigSetting = (settingBatch: string, settingGroup: string, settingName: string): Promise<string> => {
    if (settingBatch)
      return this._apiService
        .get('ConfigSetting/' + settingBatch + '/' + settingGroup + '/' + settingName, this._cacheOptions)
        .then((data: string) => {
          return Promise.resolve(data);
        });
    else
      return this._apiService.get('ConfigSetting/' + settingGroup + '/' + settingName, this._cacheOptions).then((data: string) => {
        return Promise.resolve(data);
      });
  };

  public getConfigSettingByName(settingName: string): Promise<ConfigSetting> {
    return this._apiService.get(`ConfigSettings/${settingName}`);
  }
  public getDropMembershipActionSettingsByName(settingName: string): Promise<MembershipDropActionsDto> {
    return this._apiService.get(`ConfigSettings/${settingName}`);
  }
  public getDropMembershipActionSettingsByBatch(settingBatch: string): Promise<MembershipDropActionsDto> {
    return this._apiService.get(`ConfigSettings/${settingBatch}/DropMembershipSettings`);
  }
  public getDropMembershipSettingBatches(): Promise<Array<string>> {
    return this._apiService.get(`ConfigSettings/DropMembershipSettings/SettingBatches`);
  }
  public saveDropMemberShipSettingsByName(settingName: string, data: MembershipDropActionsDto) {
    return this._apiService.post(`ConfigSettings/${settingName}`, data);
  }
  public getBatchDropConfigSettings(): Promise<BatchDropSettingsDto> {
    return this._apiService.get(`ConfigSettings/BatchDropSettings`);
  }
  public saveBatchDropConfigSettings(batchDropSettings: BatchDropSettingsDto): Promise<BatchDropSettingsDto> {
    return this._apiService.post(`ConfigSettings/BatchDropSettings`, batchDropSettings);
  }
  public getConfigSettingByBatchAndName(settingBatch: string, settingName: string): Promise<any> {
    return this._apiService.get(`ConfigSettings/${settingBatch}/${settingName}`);
  }
  public getProfileSelectorSettings(): Promise<ProfileSelectorSettingsDto> {
    return this._apiService.get('ConfigSettings/ProfileSelectorResultsGrid');
  }
  public saveProfileSelectorSettings(profileSelectorSettings: ProfileSelectorSettingsDto): Promise<ProfileSelectorSettingsDto> {
    return this._apiService.post('ConfigSettings/ProfileSelectorResultsGrid', profileSelectorSettings);
  }
  public saveConfigSettingsByBatchAndName(
    settingBatch: string,
    settingName: string,
    batchDropSettings: BatchDropSettingsDto
  ): Promise<BatchDropSettingsDto> {
    return this._apiService.post(`ConfigSettings/${settingBatch}/${settingName}`, batchDropSettings);
  }
}
